import { render, staticRenderFns } from "./feedItem.vue?vue&type=template&id=52f8aebe&scoped=true&"
import script from "./feedItem.vue?vue&type=script&lang=js&"
export * from "./feedItem.vue?vue&type=script&lang=js&"
import style0 from "./feedItem.vue?vue&type=style&index=0&id=52f8aebe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52f8aebe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/kccp/PROD/kccp-portal-web-internet-dynamic/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('52f8aebe', component.options)
    } else {
      api.reload('52f8aebe', component.options)
    }
    module.hot.accept("./feedItem.vue?vue&type=template&id=52f8aebe&scoped=true&", function () {
      api.rerender('52f8aebe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/home/feedItem.vue"
export default component.exports